import React from "react";
import defaultImage from "../../../../assets/images/default-images-empty.png";
import Modal from "./../../../shared/dialog";
import { ColorWrapper } from "../containers/common-styled";

export const ViewDetailTable = (props) => {
  const { table, listTable, onClose, pageColor } = props;

  const listChooseTable = React.useMemo(() => {
    return listTable.filter((item) => table.includes(item.id)) || [];
  }, [table, listTable]);

  const getYoutubeEmbedUrl = (url) => {
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname.includes("youtube.com")) {
        const videoId = urlObj.searchParams.get("v");
        return `https://www.youtube.com/embed/${videoId}`;
      }
      if (urlObj.hostname.includes("youtu.be")) {
        const videoId = urlObj.pathname.slice(1);
        return `https://www.youtube.com/embed/${videoId}`;
      }
      return url; // fallback
    } catch {
      return url;
    }
  };

  const renderImageEle = (url) => {
    return (
      <div
        style={{
          borderRadius: "8px",
          paddingBottom: "100%",
          backgroundColor: "#f0f0f0",
          backgroundImage: `url(${url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
    );
  };

  const renderVideoElm = (url) => {
    const embedUrl = getYoutubeEmbedUrl(url);
    return (
      <div style={{ position: "relative", paddingBottom: "100%" }}>
        <iframe
          src={embedUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            borderRadius: "8px",
          }}
        />
      </div>
    );
  };

  const getTableMedia = (table) => {
    switch (table.media_type) {
      case "image":
        return renderImageEle(table.image);
      case "youtube":
        return renderVideoElm(table.image);
      default:
        return renderImageEle(defaultImage);
    }
  };

  const renderTable = (item, _) => {
    return (
      <div className="row mb-3" key={item.id}>
        <div className="media-graw col-md-4">{getTableMedia(item)}</div>
        <div className="content-graw col-md-8">
          <ColorWrapper className="fw-bold fs-6" $color={pageColor} $isColor>
            {item.name}
          </ColorWrapper>
          <div className="mt-3 d-flex align-items-center gap-1">
            <p>席数: </p> <p>{item.seats}</p>
          </div>
          <div className="mt-2 d-flex align-items-center gap-1">
            <p>予約可能最小人数: </p>
            <p>{item.min_seats}</p>
          </div>
          {item.extra_seats ? (
            <div className="mt-2 d-flex align-items-center gap-1">
              <p>補助イス数: </p>
              <p>{item.extra_seats}</p>
            </div>
          ) : null}
          <div className="mt-3">{item.detail}</div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      id="detail-table-dialog"
      className={"detail-table-dialog"}
      title={"席を検索する"}
      isShow={true}
      closeByEscKey={false}
      showCloseButton={true}
      onCloseRequest={onClose}
      closeOnOverlayClick={false}
    >
      <div className="p-3">{listChooseTable?.map(renderTable)}</div>
    </Modal>
  );
};

export default React.memo(ViewDetailTable);
